import { CalendarClock } from 'lucide-react';

import { aggregateStackStatus } from '@/react/portainer/environments/update-schedules/common/utils';
import { StatusType } from '@/react/portainer/environments/update-schedules/types';

import { Datatable } from '@@/datatables';
import { useTableState } from '@@/datatables/useTableState';
import { getColumnVisibilityState } from '@@/datatables/ColumnVisibilityMenu';

import { EdgeUpdateListItemResponse, useList } from '../../queries/list';

import { createStore } from './store';
import { columns } from './columns';
import { TableSettingsMenus } from './TableSettingsMenus';
import { TableActions } from './TableActions';

const tableKey = 'update-schedules-list-new';

const settingsStore = createStore(tableKey, ['Target Version', 'Created']);

export function UpdateSchedulesDatatable() {
  const tableState = useTableState(settingsStore, tableKey);

  const schedulesQuery = useList<Array<EdgeUpdateListItemResponse>>({
    select: (schedules) =>
      schedules.map((schedule) => ({
        ...schedule,
        aggregatedStatus: aggregateStackStatus(
          schedule.edgeStack?.Status ?? {}
        ),
      })),
    refetchInterval: tableState.autoRefreshRate * 1000,
    includeEdgeStacks: true,
  });

  return (
    <Datatable
      title="Update & rollback"
      titleIcon={CalendarClock}
      columns={columns}
      dataset={schedulesQuery.data || []}
      initialTableState={getColumnVisibilityState(tableState.hiddenColumns)}
      settingsManager={tableState}
      isLoading={schedulesQuery.isLoading}
      renderTableSettings={(tableInstance) => (
        <TableSettingsMenus
          tableInstance={tableInstance}
          tableState={tableState}
        />
      )}
      renderTableActions={(selectedRows) => (
        <TableActions
          batchDelete={tableState.multiSelectEnabled}
          selectedRows={selectedRows}
        />
      )}
      isRowSelectable={(row) => row.original.status !== StatusType.InProgress}
      disableSelect={!tableState.multiSelectEnabled}
      data-cy="environment-update-schedules-datatable"
    />
  );
}
